import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

// import "./styles/LandingPageCaseStudy.module.scss";

const CaseStudy = ({ doc }) => {
  const { heading, subheading, link, link_text, internal_link_id } = doc?.primary || {};
  return (
    <div className="px-1 px-2xl-1 pt-5 pt-2xl-5 bg-light pb-3 pb-md-5 pb-2xl-5 cs-listing-page prismic-slice">
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className="container container-width">
        <div className="sns-h2 text-theme-primary text-center same-size-title case-study-title">
          {textResolver(heading)}
        </div>
        <div className="sns-h5 mt-3 mt-2xl-3 text-center same-size-title">
          {textResolver(subheading)}
        </div>
        <div className="row mt-md-5 mt-2xl-5 mt-2 pt-3 pt-2xl-3 cs-listing-row">
          {doc.items.map((item, index) => {
            const {
              image,
              logo,
              text,
              link_text,
              url: { url, target },
            } = item;
            return (
              <div
                key={`case-study-${index}`}
                className="col-md-6 pb-4 pb-2xl-4 position-relative cs-listing-block"
              >
                <a href={url} target={target} className="position-absolute cs-block-link" />
                <div className="case-study-image-block">
                  <PrismicImgix
                    alt={image.alt}
                    src={image.url}
                    className="case-study-image"
                    desktop="550px"
                    mobile="375px"
                    tablet="320px"
                    largeDisplay="820px"
                  />
                </div>
                <div key={`case-study-${index}`} className="case-study-block bg-white p-lg-5 p-4">
                  <div className="case-study-logo-holder mb-md-4 mb-2xl-4 mb-3 d-flex flex-column align-items-start">
                    <PrismicImgix
                      alt={logo.alt}
                      src={logo.url}
                      className="img-fluid case-study-logo"
                      desktop="430px"
                      mobile="300px"
                      tablet="270px"
                      largeDisplay="650px"
                    />
                  </div>
                  <div className="case-study-text mb-md-4 mb-2xl-4 mb-3">{textResolver(text)}</div>
                  <div className="font-weight-bold">
                    <PrismicLinkTag
                      urlText={link_text}
                      url={url}
                      target={target}
                      className="program-link ls-3 cs-program-link"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {link?.url && (
          <div className="mt-md-5 mt-2xl-5 mt-4 text-center font-weight-bold">
            <PrismicLinkTag
              urlText={link_text}
              url={link?.url}
              target={link?.target}
              className="font-weight-bold cta-green-18 text-uppercase program-link"
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default CaseStudy;
